import AdvantagesSection from './AdvantagesSection';

export default AdvantagesSection;
